import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import IconCheck from "@material-ui/icons/Check";
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  actionButton: {
    padding:'5px 10px',
    cursor:'pointer',
    color:'#5F6368',
    display:'block',
    border:'1px solid #fafa',
    borderRadius:'20px',
    "&:hover": {
        backgroundColor:'#E8F0FE'
    }
  },

  flexRow:{
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  rowItem:{
      padding:'5px 8px',
      cursor:'pointer',
   fontSize:'16px',
        "&:hover": {
            backgroundColor:'#E8F0FE'
        }
    
  },
  iconStyle:{
      fontSize:'14px',
      color:'#5F6368'
  }
}));

export default function SelectedCabins(props) {


    const classOptions={Any:'Any',M:'Economy',W:'Economy Premium',C:'Business',F:'First Class'}
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [classType,setClassType]=React.useState('Any');
 

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate=(val)=>{
    setClassType(val);
      setAnchorEl(null)

  }
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

//  React.useEffect(()=>{
//   return props?.onChange(classType)
//  },[classType])


  return (
    <div>
      <Typography style={{fontSize:'14px',textAlign:'left',marginBottom:'5px'}}>Cabin</Typography>
      <div className={classes.actionButton} onClick={handleClick}>
     
             {classOptions[classType]}
            
        <span style={{marginLeft:10}}>
        {open?<svg width="18" height="18" viewBox="0 0 24 24" focusable="false" class=" NMm5M">
  <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
</svg>:<svg width="18" height="18" viewBox="0 0 24 24" focusable="false" class=" NMm5M"><path d="M7 10l5 5 5-5H7z"></path></svg>}
        </span>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        
        <div style={{width:'200px'}}>
            {Object.keys(classOptions).map(item=><div className={classes.rowItem} onClick={()=>handleUpdate(item)}> {item==classType?<IconCheck style={{fontSize:15}}/>:<>&nbsp;&nbsp;&nbsp;</>} {classOptions[item]}</div>)}
           
        </div>
      </Popover>
    </div>
  );
}


